import { detectCurrentInAppBrowser } from "src/utils/in-app-browser";

/**
 * The `inAppBrowser` Sentry tag: the social app whose WebView we are in, or
 * "none".
 *
 * Partial uploads (FOTO-NEXTJS-144) and failed page-hide beacons (16B) lean
 * heavily towards the Facebook app, but no event carried a tag saying so, so
 * the share could only be guessed from browser names. Tagged, the two can be
 * compared directly per app.
 */
export function inAppBrowserTag(): string {
  return detectCurrentInAppBrowser().app ?? "none";
}
